import { render, staticRenderFns } from "./DMIDhead.vue?vue&type=template&id=ad181760&"
import script from "./DMIDhead.vue?vue&type=script&lang=js&"
export * from "./DMIDhead.vue?vue&type=script&lang=js&"
import style0 from "../styles/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports